import React, { useState, useEffect } from 'react';
import { Button } from '../components/ui/button';
import { Droplet, Shield, CheckCircle, Clock, ChevronDown } from 'lucide-react';
import CountdownTimer from '../components/CountdownTimer';
import LeadForm from '../components/LeadForm';
import Benefits from '../components/Benefits';
import FAQ from '../components/FAQ';

const Landing = () => {
  const [showMobileCTA, setShowMobileCTA] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 500) {
        setShowMobileCTA(true);
      } else {
        setShowMobileCTA(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToForm = () => {
    const formElement = document.getElementById('lead-form');
    if (formElement) {
      formElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

  const handleFormSuccess = () => {
    setFormSubmitted(true);
  };

  return (
    <div className="landing-page">
      {/* Header */}
      <header className="header-sticky">
        <div className="header-container">
          <div className="logo-wrapper">
            <img 
              src="https://customer-assets.emergentagent.com/job_nbz-impermeabil/artifacts/7yyp0q3v_eb6e8c4e-540b-4870-b453-66dd7146ccd2%20-%20Luiz.jpeg" 
              alt="NBZ Educação logo" 
              className="logo"
            />
          </div>
          <Button 
            onClick={scrollToForm}
            className="cta-header-btn"
          >
            <Clock className="btn-icon" />
            QUERO PARTICIPAR
          </Button>
        </div>
      </header>

      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-container">
          <div className="hero-content">
            <div className="hero-text">
              <h1 className="hero-headline">
                Antes da chuva cair, garanta que sua obra não vá por água abaixo.
              </h1>
              <h2 className="hero-subheadline">
                Aprenda as ações práticas que evitam infiltrações, retrabalhos e prejuízos — direto com um especialista em impermeabilização de obras civis.
              </h2>
              <p className="hero-support">
                💬 Aula gratuita e online — vagas limitadas!
              </p>
            </div>
          </div>

          <div className="hero-image">
            <div className="specialist-card">
              <img 
                src="/Ericoperfil.jpg" 
                alt="Especialista em Impermeabilização"
                className="specialist-img"
              />
              <div className="specialist-overlay">
                <div className="specialist-info">
                  <h3 className="specialist-name">Érico Yudi - NBZ Educação</h3>
                  <p className="specialist-title">Especialista em Impermeabilização</p>
                  <p className="specialist-exp">+32 anos de experiência</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Decorative water drops */}
        <div className="water-drop water-drop-1"></div>
        <div className="water-drop water-drop-2"></div>
      </section>

      {/* Countdown & Form Section */}
      <section className="form-section" id="form-section">
        <div className="form-container">
          <CountdownTimer targetDate="2025-11-11T19:00:00-03:00" />
          <LeadForm onSuccess={handleFormSuccess} formSubmitted={formSubmitted} />
        </div>
      </section>

      {/* Benefits Section */}
      <Benefits />

      {/* FAQ Section */}
      <FAQ />

      {/* Footer */}
      <footer className="footer">
        <div className="footer-content">
          <p className="footer-text">
            © 2025 NBZ Educação. Todos os direitos reservados.
          </p>
          <p className="footer-legal">
            Ao se inscrever você concorda em receber e-mails e mensagens operacionais. 
            Seus dados serão usados apenas para comunicação da aula.
          </p>
        </div>
      </footer>

      {/* Floating Mobile CTA */}
      {showMobileCTA && (
        <div className="floating-cta">
          <Button 
            onClick={scrollToForm}
            className="floating-cta-btn"
          >
            <Clock className="btn-icon" />
            PARTICIPAR
          </Button>
        </div>
      )}

      {/* Light points decoration */}
      <div className="light-points">
        <div className="light-point light-blue" style={{ top: '15%', left: '10%' }}></div>
        <div className="light-point light-yellow" style={{ top: '25%', right: '15%' }}></div>
        <div className="light-point light-blue" style={{ bottom: '20%', left: '20%' }}></div>
        <div className="light-point light-yellow" style={{ bottom: '35%', right: '10%' }}></div>
      </div>
    </div>
  );
};

export default Landing;